import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerLogInforme = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerLogInforme",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerLogInforme };
